import { Component, OnInit } from '@angular/core';
import {reviewList} from '../webData';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  displayClientStory: any;
  count = 0;
  showPayPal = false;
  modalToggle = 'modal is-active';
  constructor() { }

  ngOnInit() {
    this.toggleClientStory(reviewList);
  }

  toggleClientStory(clientData) {
    let count = 0;
    for (let i = 0; i < clientData.length; i++) {
      setTimeout(() => {
        if (count >= (clientData.length - 1)) {
          this.toggleClientStory(reviewList);
        }
        this.displayClientStory = clientData[i];
        count++;
      }, 10000 * i);
    }
  }

  closeModal(event) {
    console.log("modal close")
    this.modalToggle = 'modal';
     }

  buyClicked() {
    if(this.showPayPal) {
      this.showPayPal = false;
    } else {
      this.showPayPal = true;
    }
  }

}



// WEBPACK FOOTER //
// /Users/samirjha/Project/nushing/src/app/home/home.component.ts